import { useAuth } from '@/app/hooks/useAuth'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/view/components/TabsTable'
import { useMemo } from 'react'
import { ReportComissions } from './ReportComissions'
import { ReportCoupons } from './ReportCoupons'
import { ReportReferral } from './ReportReferral'
import { ReportSellers } from './ReportSellers'
import { ReportTeams } from './ReportTeams'
import { ReportTransactions } from './ReportTransactions'
import { ReportWithdraws } from './ReportWithdraws'
import { UserRoleEnum } from '@/app/services/usersService/user'
import { ReportSupports } from './ReportSupports'
import { ReportClients } from './ReportClients'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'

export const Reports = () => {
  const { appConfig } = useWhitelabelContext();
  
  const { user, isLeader, isSeller, isAdmin } = useAuth()
  const tabs = useMemo(() => {
    const result = [
      {
        name: 'Transações',
        value: 'transactions',
        component: <ReportTransactions />,
      },
    ]

    if (isAdmin) {
      result.push({
        name: 'Clientes',
        value: 'clients',
        component: <ReportClients />,
      })
    }

    result.push(
      {
        name: 'Comissões',
        value: 'comissions',
        component: <ReportComissions />,
      },
      {
        name: 'Saques',
        value: 'withdraws',
        component: <ReportWithdraws />,
      },
    )

    if (appConfig?.prizes) 
      result.push({
        name: 'Cupons',
        value: 'cupons',
        component: <ReportCoupons />,
      })

    if (!isSeller) {
      result.push({
        name: 'Vendedores',
        value: 'sellers',
        component: <ReportSellers />,
      })
      if (!isLeader) {
        result.push({
          name: 'Equipes',
          value: 'teams',
          component: <ReportTeams />,
        })
        if (
          user?.role &&
          ![UserRoleEnum.MANAGER, UserRoleEnum.SUPERVISOR].includes(user.role)
        )
          result.push(
            {
              name: 'Indicações',
              value: 'referrals',
              component: <ReportReferral />,
            },
            {
              name: 'Auditoria',
              value: 'supports',
              component: <ReportSupports />,
            },
          )
      }
    }
    return result
  }, [isAdmin, isLeader, isSeller, user?.role])

  return (
    <div className="min-h-[1280px]">
      <h1 className="text-2xl font-semibold">Relatórios</h1>
      <p className="my-5 font-medium text-black04">
        Analise os dados, escolha o tipo de relatório que deseja visualizar,
        aplique filtros conforme necessário, e obtenha uma visão clara das
        informações relevantes. Todos os relatórios podem ser exportados.
      </p>

      <div className="w-full border-b-[1px] bg-gray01" />

      <Tabs
        defaultValue="transactions"
        className="my-5 flex w-full flex-col items-start"
      >
        <TabsList className="flex h-fit flex-wrap gap-x-8 gap-y-4 py-5">
          {tabs.map((tab) => (
            <TabsTrigger
              className="pb-2 text-sm sm:text-base"
              key={tab.value}
              value={tab.value}
            >
              {tab.name}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent
            key={tab.value}
            value={tab.value}
            className="mt-8 w-full"
          >
            {tab.component}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  )
}
